import { useEffect, useState } from "react";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import { LoadingScreen } from "./components";
import Routes from "./Routes/Routes";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 3000);
  }, []);

  return (
    <>
      {loading === false ? (
        <div>
          <Routes />
        </div>
      ) : (
        <LoadingScreen />
      )}
    </>
  );
}

export default App;
